import React, { Component } from "react"
import PropTypes from "prop-types"

import PlatformSpecificFilterGroup from "app/static/frontend/search-new/containers/FilterGroup/index"

export default class FilterGroup extends Component {
    static propTypes = {
        filters: PropTypes.arrayOf(PropTypes.func).isRequired,
        permissionedFilters: PropTypes.arrayOf(PropTypes.func).isRequired,
        uniqueFilterGroupId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        hasActiveFilter: PropTypes.bool, // .isRequired,
        displayLabel: PropTypes.string,
        isOpen: PropTypes.bool, // .isRequired,
        openFilterGroup: PropTypes.func.isRequired,
        toggleFilterGroup: PropTypes.func.isRequired,
        helpText: PropTypes.string,
        alwaysOpen: PropTypes.bool,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        searchifyHeaderName: PropTypes.string,
    }

    static defaultProps = {
        hasActiveFilter: false,
        isOpen: false,
    }

    componentDidMount() {
        // if it's a filter group that's always open, open it!
        if (this.props.alwaysOpen && !this.props.isOpen) {
            this.toggleFilterGroup()
        }
    }

    shouldComponentUpdate(newProps) {
        // for some reason, every time the menu is toggled,
        // the filterGroup gets a list of filters [f1, f2, f3] that are
        // functionally the same as the previous filters, but referentially
        // different. So we need to avoid that.
        return (
            this.props.isOpen !== newProps.isOpen ||
            this.props.hasActiveFilter !== newProps.hasActiveFilter ||
            this.props.filters.length !== newProps.filters.length ||
            this.props.searchFilterTerm !== newProps.searchFilterTerm
        )
    }

    openFilterGroup = () => {
        this.props.openFilterGroup(this.props.uniqueFlvId, this.props.uniqueFilterGroupId)
    }

    toggleFilterGroup = () => {
        this.props.toggleFilterGroup(this.props.uniqueFlvId, this.props.uniqueFilterGroupId)
    }

    render() {
        return (
            Boolean(this.props.permissionedFilters.length) && (
                <PlatformSpecificFilterGroup
                    {...this.props}
                    openFilterGroup={this.openFilterGroup}
                    renderedFilters={this.props.permissionedFilters}
                    toggleFilterGroup={this.toggleFilterGroup}
                />
            )
        )
    }
}
